import axios from 'axios';
import { UPDATE_USER } from '../../constants';

export const updateUser = (uId, data, onError, onClose) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadUpdateUser());
  axios
    .put(`admin/editUser?userId=${uId}`, data, config)
    .then(async (res) => {
      await onClose();
      await dispatch(setUpdateUser(res));
    })
    .catch((err) => {
      dispatch(errorUpdateUser(err.response));
      onError(err.response);
    });
};

export const loadUpdateUser = () => ({
  type: UPDATE_USER.LOAD,
});

export const setUpdateUser = (data) => ({
  type: UPDATE_USER.SUCCESS,
  payload: data.data,
});

export const errorUpdateUser = (error) => ({
  type: UPDATE_USER.FAIL,
  payload: error,
});
